import React from 'react'
import PropTypes from 'prop-types'

import MainFirst from './../block/MainFirst'
import Cards1 from './../block/Cards1'
import PhotoGallarySlyder from './../block/PhotoGallarySlyder'
import Raschet from './../block/Raschet'
import Kontakti from './../block/Kontakti'

class Vitrazi extends React.Component {

  render() {

    const { data, protocol, assets_path } = this.props

    return (
      <>
        <MainFirst
          data={data?.main_first || {}}
          protocol={protocol}
          assets_path={assets_path}
        />
        <Cards1
          title={`Витражи <span>от производителя</span>`}
          rtext={`[Надежность каждого решения]`}
          text={`Мы создаём витражи различного вида: тифани, пленочный витраж, заливной. Подберем лучший вариант по вашему бюджету.`}
          list={data?.cards1?.list || []}
          cols={2}
          margin={`y`}
          bg={2}
        />
        <Raschet
          data={data?.sdiz || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <PhotoGallarySlyder
          data={data?.photogallary || {}}
        />
        <Raschet
          data={data?.raschet || {}}
          assets_path={assets_path}
          dark_bg={data?.dark_bg || ''}
          dark_bg_mob={data?.dark_bg_mob || ''}
        />
        <Kontakti
          data={data?.kontakti || {}}
          assets_path={assets_path}
          cardsOnly={true}
        />
      </>
    )
  }
}

Vitrazi.propTypes = {
  data: PropTypes.object,
  protocol: PropTypes.string,
  assets_path: PropTypes.string
}

Vitrazi.defaultProps = {
  data: {},
  protocol: 'https',
  assets_path: 'assets'
}

export default Vitrazi